import React from "react";

const StatisticsOrder = ({userRelatedData}) => {

  return (
    <div className="theme-section">
      <h1 className="section-tittle">Total Orders ({userRelatedData.order_related_statistics?.total_order})</h1>
      <div className="data-table-wrapper">
        <div className="table-container">
          <table className="table">
            <tbody>
              <tr>
                <td>Pendding</td>
                <td className="text-end">{userRelatedData.order_related_statistics?.total_pending_order}</td>
              </tr>
              <tr>
                <td>Running</td>
                <td className="text-end">{userRelatedData.order_related_statistics?.total_running_order}</td>
              </tr>
              <tr>
                <td>Finished</td>
                <td className="text-end">{userRelatedData.order_related_statistics?.total_finished_order}</td>
              </tr>
              <tr>
                <td>Canceled</td>
                <td className="text-end">{userRelatedData.order_related_statistics?.total_canceled_order}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default React.memo(StatisticsOrder);
